module.exports = __webpack_public_path__ + "public/img/img-mobile-prakerja-2.cb820968.png";